import { TemplateType } from '@ekkogmbh/apisdk';
import { InsertDriveFileOutlined } from '@mui/icons-material';
import { Stack, Tooltip, Typography } from '@mui/material';

// =========================================================
// Type Configuration
// =========================================================

interface TemplateTypeConfig {
  /** Short label rendered below the file icon. */
  shortLabel: string;
  /** Full description shown in the tooltip. */
  label: string;
  /** Color applied to both the icon and label. */
  color: string;
}

const TEMPLATE_TYPE_CONFIG: Record<TemplateType, TemplateTypeConfig> = {
  [TemplateType.APACHE_FOP]: {
    shortLabel: 'XSL',
    label: 'Apache FOP (XSL-FO)',
    color: '#2e9e24',
  },
  [TemplateType.SVG_TERA]: {
    shortLabel: 'SVG',
    label: 'SVG (Tera)',
    color: '#1565c0', // blue
  },
};

// =========================================================
// TemplateTypeIndicator
// =========================================================

interface TemplateTypeIndicatorProps {
  type: TemplateType;
}

export default function TemplateTypeIndicator({ type }: TemplateTypeIndicatorProps): React.JSX.Element {
  const config = TEMPLATE_TYPE_CONFIG[type];

  if (!config) {
    return (
      <Tooltip title={type}>
        <span>{type}</span>
      </Tooltip>
    );
  }

  return (
    <Tooltip title={config.label}>
      <Stack alignItems="center" spacing={0.25}>
        <InsertDriveFileOutlined sx={{ color: config.color }} />
        <Typography variant="caption" fontSize="0.6rem" fontWeight={700} lineHeight={1} sx={{ color: config.color }}>
          {config.shortLabel}
        </Typography>
      </Stack>
    </Tooltip>
  );
}
